import React, { PureComponent } from 'react'

import { toArray, get } from 'lodash'
import { Select, Avatar } from "@driftt/tide-core-legacy"
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import { PARTICIPANT_TYPES } from './constants'

class SingleParticipantAction extends PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      selectedParticipant: get(props.rule, 'data.item.action.options.userIds[0]', null)
    }
  }

  componentDidMount() {
    const { selectedParticipant } = this.state
    const { setActionParticipants } = this.props

    if (!!selectedParticipant) {
      setActionParticipants({ participants: [selectedParticipant], participantType: PARTICIPANT_TYPES.SINGLE })
    }
  }

  getFormattedUsersOptions() {
    return toArray(this.props.users).map((user) => {
      return { label: getDisplayName(user), value: Number(user.id) }
    })
  }

  renderSelectOption = ({ value }) => {
    const { users } = this.props
    const user = this.props.users[value]
    return (
      <div className="choice-dropdown-option">
        <Avatar user={user} />
        <span className="choice-option-value">{getDisplayName(user)}</span>
      </div>
    )
  }

  onParticipantSelected = (selectedOption) => {
    const { setActionParticipants, users } = this.props

    this.setState({ selectedParticipant: selectedOption },
      () => {
        const participants = !!this.state.selectedParticipant ? [this.state.selectedParticipant.value] : []
        setActionParticipants({ participants: participants, participantType: PARTICIPANT_TYPES.SINGLE })
      }
    )
  }

  render() {
    return (
      <div className="participant-action single-participant">
        <div className="participant-action-selector-description">Who do you want to add?</div>
        <Select
          className="participant-single-select"
          autoFocus={true}
          options={this.getFormattedUsersOptions()}
          pageSize={10}
          clearable={true}
          optionRenderer={this.renderSelectOption}
          valueRenderer={this.renderSelectOption}
          placeholder='Add a participant...'
          value={this.state.selectedParticipant}
          onChange={this.onParticipantSelected}
          size="large"
        />
      </div>
    )
  }
}

export default SingleParticipantAction


// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/ActionEditor/ParticipantActions/SingleParticipantAction.js